import { render, staticRenderFns } from "./systemAbnormalOrder.vue?vue&type=template&id=0e28a864&scoped=true&"
import script from "./systemAbnormalOrder.vue?vue&type=script&lang=js&"
export * from "./systemAbnormalOrder.vue?vue&type=script&lang=js&"
import style0 from "./systemAbnormalOrder.vue?vue&type=style&index=0&id=0e28a864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e28a864",
  null
  
)

export default component.exports